import { handleActions } from "redux-actions";
import { login, logout, loginFail } from "../actions/actions";
import { DEFECT_KEY } from "../defect";

const notConnectedUser = { [DEFECT_KEY]: "Not connected" };

export default handleActions(
  {
    [login]: (state, action) => ({ ...action.payload }),
    [logout]: () => notConnectedUser,
    [loginFail]: (state, action) => {
      if (action.payload.error === "Unauthorized")
        return { ...notConnectedUser, message: "Access not granted" };
      return { ...notConnectedUser, message: "Unexpected error" };
    }
  },
  notConnectedUser
);
